export default "__VITE_ASSET__n8cRwuMn__"